import setTimerId from '../actions/setTimerId';
import { getToastViewState } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator for the action which changes the current timerId in the state as per the action message
 */
export default mutator(
    setTimerId,
    function setTimerIdMutator(actionMessage: { timerId: NodeJS.Timer | null }) {
        const { timerId } = actionMessage;
        getToastViewState().timerId = timerId;
    }
);
